// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:29.487Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/jquery.ajaxQueue': [],
})(this, function (m_module, Backbone, $) {

var M = m_module.M;

"use strict";

  // TODO: Fix namespace, e.g. M.Api.DeliveryEstimator

  M.Model = M.Model || {};
  M.Model.DeliveryEstimator = M.Model.DeliveryEstimator || {};

  /**
   * The new delivery estimator javascript api library
   *
   * This allows us to interface with the new api, and
   * produce delivery estimates on the front-end of
   * our web app
   */
  M.Model.DeliveryEstimator.Api = Backbone.Model.extend({
    // TODO no instance methods use
    // static methods defined below instead
  }, {
    // static

    /**
     * construct a url from the given hostname and path
     *
     * Arguments
     * host -- the host to construct a url with
     * path -- the path to construct a url with
     */
    _constructUrl: function(scheme, host, path) {
      return scheme + '//' + host + path;
    },

    /**
     * the interface for making api requests (private method)
     * used by the api object
     *
     * Arguments
     * url -- the url to make a request to
     * type -- the type of request (ie. GET, PUT, POST, DELETE, HEAD...)
     * data -- the json data to send with the request
     * success -- callback for if the transaction succeeds
     * error -- callback for if the transaction fails
     */
    _makeRequest: function(url, type, data, success, error) {
      // allows this method to be called without callbacks
      success = typeof success === 'function'? success : function(){};
      error = typeof error === 'function'? error : function(){};

      $.ajaxQueue({
        type: type,
        url: url,
        dataType: 'json',
        data: data,
        contentType: 'application/json; charset=utf-8',
        success: success,
        error: error
      });
    },

    /**
     * a dictionary of endpoints for the api
     */
    _PATHS: {
      delivery_estimate: '/api/delivery-estimate'
    },

    /**
     * The url scheme to use
     */
    _SCHEME: window.location.protocol,

    /**
     * host string of the current host
     */
    _HOST: window.location.host,

    /**
     * #####
     *
     * This section contains all the public methods to hit
     * endpoints for the Delivery Estimator API
     *
     * #####
     */

    /**
     * obtains a delivery estimate, from the API,  based on the data
     * supplied to the method
     *
     * Arguments
     * po -- an EstimatorPO object that represents the state of
     *       order
     * success -- callback for if the transaction succeeds
     * error -- callback for if the transaction fails
     */
    deliveryEstimate: function(po, success, error) {
      var data = JSON.stringify([po]);
      var url = M.Model.DeliveryEstimator.Api._constructUrl(
        M.Model.DeliveryEstimator.Api._SCHEME,
        M.Model.DeliveryEstimator.Api._HOST,
        M.Model.DeliveryEstimator.Api._PATHS['delivery_estimate']
      );

     M.Model.DeliveryEstimator.Api. _makeRequest(url, 'POST', data, success, error);
    }

  });

return {
};

});

